module.exports = __webpack_public_path__ + "img/icon_live_vfull.131a4176.svg";